import { MobileAppBuildStatus } from "src/utils/enums"
import { IosBuild } from "../../entities/iosBuild"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	buildNo: number
	version: string
	publishDate: number
	status: MobileAppBuildStatus
}

export async function iosBuildAddApi(payload: RequestDataShape, token: string) {
	const endpoint = "/ios/build/add/v1"
	const requester = new ApiRequester<RequestDataShape, IosBuild>(endpoint)
	return await requester.sendRequest(payload, token)
}
